:root {
  font-family: Arial, Helvetica, sans-serif;
}
body {
  padding: 0;
  margin: 0;
  --sidebar-width: 2.1em;
  --controlpanel-width: 10em;
  position: fixed;
}

kbd {
  background-color: #eee;
  border-radius: 3px;
  border: 1px solid #b4b4b4;
  box-shadow:
  0 1px 1px rgba(0, 0, 0, 0.2),
  0 2px 0 0 rgba(255, 255, 255, 0.7) inset;
  color: #333;
  display: inline-block;
  font-size: 0.85em;
  font-weight: 700;
  line-height: 1;
  padding: 2px 4px;
  white-space: nowrap;
  position: relative;
}

kbd + kbd {
  margin-left: 1em;
  &::before {
    content: "+";
    position: absolute;
    left: -.5em;
    transform: translateX(-50%);
  }
}

.viewer {
  display: grid;
  grid:
  "sidebar videoplayer controlpanel" 1fr
  "sidebar detectionbar detectionbar" var(--force-detectionbar-height, var(--detectionbar-height))
  "sidebar behaviour behaviour" var(--force-behaviour-height, var(--behaviourbar-height))
  / var(--sidebar-width) 1fr var(--force-controlpanel-width, var(--controlpanel-width));
  &.no_controlpanel {
    --force-controlpanel-width: 0;
  }
  &.no_detectionbar {
    --force-detectionbar-height: 0;
  }
  &.no_behaviourbar {
    --force-behaviour-height: 0;
  }
  height: 100vh;
  width: 100vw;
}

.sidebar {
  grid-area: sidebar;
}

.videoplayer {
  grid-area: videoplayer;
  overflow: hidden;
}
.controlpanel {
  grid-area: controlpanel;
  display: flex;
  flex-flow: column nowrap;
  overflow-y: scroll;
}

.detectionbar {
  grid-area: detectionbar;
}

.behaviour {
  grid-area: behaviour;
  background-color: hsl(140, 50%, 95%);
  overflow: scroll;
}

.popup_sizer {
  margin-left: calc(max(var(--sidebar-width) + 1em, 3em));
  max-width: fit-content;
}
